import React from "react";
import { Route, RouteProps } from "react-router";

export interface IPublicRouteProps extends RouteProps {
  Layout?: any;
}

const PublicRoute: React.FC<IPublicRouteProps> = (props) => {
  const { Layout, component } = props;

  return Layout ? (
    <Layout>
      <Route {...props} component={component} render={undefined} />
    </Layout>
  ) : (
    <Route {...props} component={component} render={undefined} />
  );
};

export default PublicRoute;
